import { DataBean } from "../DataBean";

export class SIIFTCON17Value extends DataBean {


    public async getSIIFTCON17ValueByIDSIIFAuxiliary(siifAuxiliaryID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSIIFTCON17ValueByIDSIIFAuxiliary_Number", [siifAuxiliaryID]);
    }

 
}